// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a66d6de","553":"a89b2fad","977":"1c16878e"}[chunkId] + ".chunk.js";
};